/* eslint-disable no-nested-ternary */

export function isDenominationMixed(description) {
  if (description === "ATM Cassette" || description === "CDM Cassette") {
    return false;
    // eslint-disable-next-line no-else-return
  } else {
    return true;
  }
}
export const makeEditPayload = (
  location,
  countriesList,
  routesList,
  currenciesList
) => {
  const _payload = {
    ...location,
    cashCenterId: location.cashCenterId
      ? {
          cashCenterId: location.cashCenterId,
          name: location.cashCenter,
        }
      : "",
    customerId: location.customerId
      ? { customerId: location.customerId, name: location.customer }
      : "",
    category: location.category
      ? { id: location.category, text: location.category }
      : "",
    locationType: location.locationType
      ? { id: location.locationType, text: location.locationType }
      : "",
    status: location.status
      ? { id: location.status, text: location.status }
      : "",
    siteType: location.siteType
      ? { id: location.siteType, text: location.siteType }
      : "",
    state: location.state ? { id: location.state, text: location.state } : "",
    city: location.city ? { id: location.city, text: location.city } : "",
    emirate: location.emirate
      ? { id: location.emirate, text: location.emirate }
      : "",
    fixingSide: location.fixingSide
      ? { id: location.fixingSide, text: location.fixingSide }
      : "",
    loadingSide: location.loadingSide
      ? { id: location.loadingSide, text: location.loadingSide }
      : "",
    machineType: location.machineType
      ? { description: location.machineType }
      : "",
    maker: location.maker ? { name: location.maker } : "",
    model: location.model ? { name: location.model } : "",
    siteSLAs:
      location.siteSLAs?.map((elm) => ({
        serviceType: elm.serviceType
          ? { id: elm.serviceType, text: elm.serviceType }
          : "",
        activityType: elm.activityType
          ? { id: elm.activityType, text: elm.activityType }
          : "",
        responseTime: elm.resolutionTime,
        attendedTime: elm.attendedTime,
        resolutionTime: elm.resolutionTime,
      })) || [],
    operationalWindows:
      location.operationalWindows?.map((elm) => ({
        startDateTime: elm.startDateTime ? new Date(elm.startDateTime) : null,
        endDateTime: elm.endDateTime ? new Date(elm.endDateTime) : null,
        cutOffTime: elm.cutOffTime ? new Date(elm.cutOffTime) : null,
      })) || [],
    serviceWindows:
      location.serviceWindows?.map((elm) => ({
        startDateTime: elm.startDateTime ? new Date(elm.startDateTime) : null,
        endDateTime: elm.endDateTime ? new Date(elm.endDateTime) : null,
        cutOffTime: elm.cutOffTime ? new Date(elm.cutOffTime) : null,
      })) || [],
    cassettes:
      location.cassettes?.map((elm) => {
        return {
          description: { id: elm.description, text: elm.description },
          denomination: elm.denomination,
          currency: isDenominationMixed(elm.description)
            ? ""
            : elm.denomination
              ? currenciesList.find(
                  (item) => item.shortName === elm.denomination.split(" ")[0]
                )
              : "",
          multiple: isDenominationMixed(elm.description)
            ? ""
            : elm.denomination
              ? {
                  id: Number(elm.denomination.split(" ")[1]),
                  text: Number(elm.denomination.split(" ")[1]),
                }
              : "",
          cassetteType: elm.cassetteType
            ? { id: elm.cassetteType, text: elm.cassetteType }
            : "",
          maker: elm.maker,
          limit: elm.limit,
          dualScanning: elm.dualScanning,
        };
      }) || [],
    denominations:
      location.denominations?.map((elm) => ({
        currency: elm.currency
          ? currenciesList.find((item) => item.shortName === elm.currency)
          : "",
        multiple: elm.multiple
          ? { id: Number(elm.multiple), text: Number(elm.multiple) }
          : "",
        shape: elm.shape ? { id: elm.shape, text: elm.shape } : "",
        version: elm.version,
      })) || [],
    replenishmentModels:
      location.replenishmentModels?.map((elm) => ({
        code: elm.code,
        denominations:
          elm.denominations?.map((item) => {
            return {
              currency: item.denomination
                ? currenciesList.find(
                    (curr) => curr.shortName === item.denomination.split(" ")[0]
                  )
                : "",
              multiple: item.denomination
                ? {
                    id: Number(item.denomination.split(" ")[1]),
                    text: Number(item.denomination.split(" ")[1]),
                  }
                : "",
              noOfCassettes: item.noOfCassettes || 0,
              noOfNotes: item.noOfNotes || 0,
            };
          }) || [],
      })) || [],
    siteRepresentatives:
      location.siteRepresentatives?.map((elm) => ({
        name: elm.name,
        employeeId: elm.employeeId,
        mobileNo: elm.mobileNo,
        email: elm.email,
      })) || [],
  };
  if (location.routeNo) {
    _payload.routeNo = routesList.find(
      (elm) => elm.routeNo === location.routeNo
    ) || { routeNo: location.routeNo, description: location.routeNo };
  }
  if (location.country) {
    _payload.country = countriesList.find(
      (elm) => elm.name === location.country
    );
  }

  return _payload;
};
export const makePayload = (servicePoint) => {
  const _payload = {
    customerId: servicePoint.customerId?.customerId || "",
    customer: servicePoint.customerId?.name || "",
    cashCenterId: servicePoint.cashCenterId?.cashCenterId || "",
    cashCenter: servicePoint.cashCenterId?.name || "",
    locationId: servicePoint.locationId,
    locationName: servicePoint.locationName,
    locationCode: servicePoint.locationCode,
    category: servicePoint.category.id,
    routeNo: servicePoint.routeNo?.routeNo || "",
    locationType: servicePoint.locationType.id,
    status: servicePoint.status?.id || "",
    siteType: servicePoint.siteType?.id || "",
    fixingSide: servicePoint.fixingSide?.id || "",
    loadingSide: servicePoint.loadingSide?.id || "",
    machineType: servicePoint.machineType?.description || "",
    maker: servicePoint.maker?.name || "",
    model: servicePoint.model?.name || "",
    lockSerialNo: servicePoint.lockSerialNo,
    machineSerialNo: servicePoint.machineSerialNo,
    barcode: servicePoint.barcode,
    siteLimit: servicePoint.siteLimit,
    distanceFromBase: servicePoint.distanceFromBase,
    coLocatedGroupNo: servicePoint.coLocatedGroupNo,
    maximumCassettes: servicePoint.maximumCassettes,
    requiresCashierCount: servicePoint.requiresCashierCount,
    requiresEVhr: servicePoint.requiresEVhr,
    hasSecurityAlarm: servicePoint.hasSecurityAlarm,
    alarmDetails: servicePoint.alarmDetails,
    country: servicePoint.country?.name || "",
    state: servicePoint.state?.id || "",
    emirate: servicePoint.emirate?.id || "",
    city: servicePoint.city?.id || "",
    address: servicePoint.address,
    longitude:
      !servicePoint.longitude || servicePoint.longitude === "0"
        ? 0
        : servicePoint.longitude,
    latitude:
      !servicePoint.latitude || servicePoint.latitude === "0"
        ? 0
        : servicePoint.latitude,
    lockInstallationDate: servicePoint.lockInstallationDate,
    firstServiceDate: servicePoint.firstServiceDate,
    decomissionedDate: servicePoint.decomissionedDate,
    followStandardModels: servicePoint.followStandardModels,
    followStandardDenominations: servicePoint.followStandardDenominations,
    followStandardCassettes: servicePoint.followStandardCassettes,
    dedicatedSerials: servicePoint.dedicatedSerials || [],
    serviceDays: servicePoint.serviceDays,
    allowedDays: servicePoint.allowedDays,
    siteSLAs:
      servicePoint.siteSLAs?.map((elm) => ({
        serviceType: elm.serviceType?.text || "",
        activityType: elm.activityType?.text || "",
        responseTime: Number(elm.resolutionTime),
        attendedTime: Number(elm.attendedTime),
        resolutionTime: Number(elm.resolutionTime),
      })) || [],
    operationalWindows:
      servicePoint.operationalWindows?.map((elm) => ({
        startDateTime: elm.startDateTime || "",
        endDateTime: elm.endDateTime || "",
        cutOffTime: elm.cutOffTime || "",
      })) || [],
    serviceWindows:
      servicePoint.serviceWindows?.map((elm) => ({
        startDateTime: elm.startDateTime || "",
        endDateTime: elm.endDateTime || "",
        cutOffTime: elm.cutOffTime || "",
      })) || [],
    cassettes: servicePoint.followStandardCassettes
      ? []
      : servicePoint.cassettes?.map((elm) => ({
          description: elm.description?.id || "",
          denomination: elm.denomination,
          cassetteType: elm.cassetteType?.text || "",
          maker: elm.maker,
          limit: elm.limit,
          dualScanning: elm.dualScanning,
        })) || [],
    denominations: servicePoint.followStandardDenominations
      ? []
      : servicePoint.denominations?.map((elm) => ({
          currency: elm.currency?.shortName || "",
          multiple: elm.multiple?.id || "",
          shape: elm.shape?.id || "",
          version: elm.version,
        })) || [],
    replenishmentModels: servicePoint.followStandardModels
      ? []
      : servicePoint.replenishmentModels?.map((elm) => ({
          code: elm.code,
          denominations: elm.denominations.map((item) => ({
            denomination:
              item.currency && item.multiple
                ? `${item.currency.shortName} ${item.multiple.text}`
                : "",
            noOfCassettes: item.noOfCassettes || 0,
            noOfNotes: item.noOfNotes || 0,
          })),
        })) || [],
    siteRepresentatives:
      servicePoint.siteRepresentatives?.map((elm) => ({
        name: elm.name,
        employeeId: elm.employeeId,
        mobileNo: elm.mobileNo,
        email: elm.email,
      })) || [],
  };
  return _payload;
};
